import { Meteor } from 'meteor/meteor'
import moment from 'moment'
import { SET_MY_LAWYER } from '../reducers/lawyers'

import { dispatch } from '../store'
import { SET_USERS, SET_MY_PROFILE } from '../reducers/user'

const fetchUsers = async (_id: string, updateAt: ?Date = null, profileUser = {}) => {
  const userId = _id ? _id : null

  if (!_id) return false

  const myUser = profileUser[_id]

  let mustFetch = true

  // Reuse cache if user is not updated :)
  if (myUser && updateAt && myUser.updateAt === updateAt) {
    mustFetch = false
  }
  if (mustFetch) {
    const users = userId ? await Meteor.promise('getUsers', userId) : null

    dispatch({
      type: SET_USERS,
      payload: users,
    })
    return users
  }
}

const fetchLawyers = async (_id: string) => {
  const payload = await Meteor.promise('getLawyerById', _id)

  dispatch({
    type: SET_MY_LAWYER,
    payload,
  })
}

const fetchMe = async () => {
  const user = await Meteor.user()

  if (user) {
    const { profile } = user

    let parent: any = null

    if (profile.parentId) parent = await Meteor.promise('getParentInfo')

    const newProfile = {
      ...profile,

      _id: user._id,
      cardLastDigits: user.cardLastDigits,
      cardExpirationDate: user.cardExpirationDate,
      email: user?.emails?.[0]?.address || '',

      birthday:
        profile.birthday &&
        profile.birthday !== '' &&
        moment(profile.birthday).format('YYYY-MM-DD'),
    }

    if (parent) {
      newProfile.cardLastDigits = parent.cardLastDigits
      newProfile.cardExpirationDate = parent.cardExpirationDate
      newProfile.mandateId = parent.mandateId
      newProfile.offerId = parent.offerId
      newProfile.paimentExternal = parent.paimentExternal
      newProfile.cgu = parent.cgu
      newProfile.callPartner = parent.callPartner
    }

    dispatch({
      type: SET_MY_PROFILE,
      payload: newProfile,
    })
  }
}

export { fetchUsers, fetchMe, fetchLawyers }
